import axios from 'axios'
import FOPForm from '../../../components/checkout/delivery/legal-person-info-forms/FOPForm'
import FiliaForm from '../../../components/checkout/delivery/legal-person-info-forms/FiliaForm'
import OtherForm from '../../../components/checkout/delivery/legal-person-info-forms/OtherForm'

export default {
  state: {
    legalPersonInfo: [],
    isLegalFormValid: false,
    paymentTypes: [],
    payPartsValue: null,
    legalPersonFormComponent: null,
    isPaymentFormEmpty: false,
    monobankRepeatPaymentStatus: null,
    vatForm: {
      needVatFacture: false,
      isAnotherReceiver: false,
      formType: {},
      formData: {},
      isFormDataValid: {
        legal: false,
        legal2: false,
        person: false
      },
      isNipError: {
        legal: false,
        legal2: false
      }
    }
  },
  getters: {
    isVatFormValid (state, getters, rootState) {
      if (state.vatForm.needVatFacture) {
        if (state.vatForm.formType.value === 'person') {
          if (state.vatForm.isAnotherReceiver) {
            return state.vatForm.isFormDataValid.person && state.vatForm.isFormDataValid.legal2 && !state.vatForm.isNipError.legal2
          } else {
            return state.vatForm.isFormDataValid.person
          }
        } else {
          if (state.vatForm.isAnotherReceiver) {
            return state.vatForm.isFormDataValid.legal && state.vatForm.isFormDataValid.legal2 && !state.vatForm.isNipError.legal2
          } else {
            return state.vatForm.isFormDataValid.legal && !state.vatForm.isNipError.legal
          }
        }
      }
      return true
    },
    isLegalFormValid (state, getters, rootState) {
      if (!rootState.checkout.formData.legalPersonInfo || !rootState.checkout.formData.paymentType) return false

      const { formRef, firmEgr, firmTitle, full_name: organization, phoneNumberForPayment, documentNdsStatus } = rootState.checkout.formData.legalPersonInfo
      const filiaRef = '82a553c6-4f94-11e8-a3de-005056b2fc3d'
      const fopRef = 'd558bfcc-7456-11df-ad52-000c29118aa7'

      const isFiliaFormValid = !!(formRef === filiaRef && firmEgr && firmEgr.length === 8 && firmTitle && documentNdsStatus)
      const isFopFormValid = !!(formRef === fopRef && organization && documentNdsStatus)
      const isOtherFormValid = !!(formRef !== filiaRef && formRef !== fopRef && organization && documentNdsStatus)
      const isValidPhoneNumberForPayment = !!(!phoneNumberForPayment || phoneNumberForPayment.isValid)

      return (isFiliaFormValid || isFopFormValid || isOtherFormValid) && isValidPhoneNumberForPayment
    },
    clientPhone (state, getters, rootState) {
      return rootState.checkout.managersClientData?.phone ?? false
    },
    isLegalPerson (state) {
      return state.vatForm.needVatFacture
    }
  },
  mutations: {
    SET_VAT_FORM_FACTURE: (state, data) => {
      state.vatForm.needVatFacture = data
      localStorage.setItem('vatForm', JSON.stringify(state.vatForm))
    },
    SET_VAT_FORM_TYPE: (state, data) => {
      state.vatForm.formType = data
      localStorage.setItem('vatForm', JSON.stringify(state.vatForm))
    },
    SET_VAT_FORM_DATA: (state, data) => {
      state.vatForm.formData = data
      localStorage.setItem('vatForm', JSON.stringify(state.vatForm))
    },
    SET_VAT_FORM: (state, data) => {
      state.vatForm = { ...state.vatForm, ...data }
      localStorage.setItem('vatForm', JSON.stringify(state.vatForm))
    },
    COLLECT_VAT_FORM_DATA: (state, data) => {
      state.vatForm.formData = { ...state.vatForm.formData, ...data }
      localStorage.setItem('vatForm', JSON.stringify(state.vatForm))
    },
    SET_VAT_FORM_IS_ANOTHER: (state, data) => {
      state.vatForm.isAnotherReceiver = data
      localStorage.setItem('vatForm', JSON.stringify(state.vatForm))
    },
    SET_VAT_FORM_VALID: (state, data) => {
      state.vatForm.isFormDataValid[data.name] = data.value
    },
    SET_NIP_ERROR: (state, data) => {
      state.vatForm.isNipError[data.name] = data.value
      localStorage.setItem('vatForm', JSON.stringify(state.vatForm))
    },
    SET_LEGAL_PERSON_INFO: (state, data) => {
      state.legalPersonInfo = data
    },
    SET_IS_LEGAL_FORM_VALID: (state, bool) => {
      state.isLegalFormValid = bool
    },
    SET_PAYMENT_TYPES: (state, data) => {
      state.paymentTypes = data
    },
    SET_PAY_PARTS_VALUE: (state, data) => {
      state.payPartsValue = data
    },
    SET_LEGAL_PERSON_FORM_COMPONENT (state, component) {
      state.legalPersonFormComponent = component
    },
    SET_IS_PAYMENT_FORM_EMPTY_WARNING (state, bool) {
      state.isPaymentFormEmpty = bool
    },
    SET_MONOBANK_REPEAT_STATUS (state, bool) {
      state.monobankRepeatPaymentStatus = bool
    }
  },
  actions: {
    CHANGE_VAT_FORM_FACTURE: ({ commit, rootGetters, rootState }, data) => {
      commit('SET_VAT_FORM_FACTURE', data)
    },
    CHANGE_VAT_FORM_TYPE: ({ commit, rootGetters, rootState }, data) => {
      commit('SET_VAT_FORM_TYPE', data)
    },
    CHANGE_VAT_FORM_DATA: ({ commit, rootGetters, rootState }, data) => {
      commit('SET_VAT_FORM_DATA', data)
    },
    CHANGE_VAT_FORM: ({ commit, rootGetters, rootState }, data) => {
      commit('SET_VAT_FORM', data)
    },
    COLLECT_VAT_FORM_DATA: ({ commit, rootGetters, rootState }, data) => {
      commit('COLLECT_VAT_FORM_DATA', data)
    },
    CHANGE_VAT_FORM_IS_ANOTHER: ({ commit, rootGetters, rootState }, data) => {
      commit('SET_VAT_FORM_IS_ANOTHER', data)
    },
    CHANGE_VAT_FORM_VALID: ({ commit, rootGetters, rootState }, data) => {
      commit('SET_VAT_FORM_VALID', data)
    },
    CHANGE_NIP_ERROR: ({ commit, rootGetters, rootState }, data) => {
      commit('SET_NIP_ERROR', data)
    },
    FETCH_LEGAL_PERSON_INFO: ctx => {
      axios
        .get(ctx.rootGetters.urlLanguagePrefix + '/shop/checkout/ownership-types/')
        .then(response => ctx.commit('SET_LEGAL_PERSON_INFO', response.data))
        .catch(() => ctx.commit('SET_ERROR_FROM_SERVER', ctx.rootGetters.translations('server_error')))
    },
    GET_LEGAL_HISTORY: ctx => {
      if (!ctx.rootState.checkout.isGuest) {
        axios
          .get(ctx.rootGetters.urlLanguagePrefix + '/shop/checkout/get-legal-history/')
          .then(response => {
            if (!response.data) return
            const {
              edrpou: egr,
              inn,
              vat_payer: pdvStatus,
              company_name: fullName,
              ownership_type_id: formId
            } = response.data

            const legalPersonInfo = {
              formId: formId.toString(),
              egr,
              inn,
              full_name: fullName,
              pdv_status: pdvStatus === 'Y',
              status: 'success'
            }
            const selectedForm = ctx.state.legalPersonInfo.find(el => +el.id === formId)
            ctx.dispatch('SET_LEGAL_PERSON_INFO_COMPONENT_ACTION', selectedForm.ref)
            ctx.commit('REDUCE_FORM_DATA', { legalPersonInfo })
          })
          .catch(() => ctx.commit('SET_ERROR_FROM_SERVER', ctx.rootGetters.translations('server_error')))
      }
    },
    FETCH_LEGAL_INFO_BY_CODE: ({ commit, rootGetters, rootState }, code) => {
      commit('SET_LOADING_COMPONENTS', { legalPersonPayment: true })

      axios
        .get(rootGetters.urlLanguagePrefix + '/shop/cart/legal-info/', { params: { code } })
        .then(response => {
          const { formId, egr, inn, formRef } = rootState.checkout.formData.legalPersonInfo
          const legalPersonInfo = { formId, formRef, inn, egr, ...response.data, documentNdsStatus: '0' }
          commit('REDUCE_FORM_DATA', { legalPersonInfo })
        })
        .catch(() => commit('SET_ERROR_FROM_SERVER', rootGetters.translations('server_error')))
        .finally(() => commit('SET_LOADING_COMPONENTS', { legalPersonPayment: false }))
    },
    FETCH_PAYMENT_TYPE: (ctx, data) => {
      const params = data ? { ...data } : {}

      ctx.dispatch('SET_LOADING_COMPONENT', { paymentsTypes: true }, { root: true })

      axios
        .get(ctx.rootGetters.urlLanguagePrefix + '/shop/checkout/get-payments/', { params })
        .then(response => ctx.commit('SET_PAYMENT_TYPES', response.data.payments))
        .then(() => {
          if (ctx.rootState.init.config.service?.is_bonus_service_active) {
            return ctx.dispatch('FETCH_CART_BONUSES_INFO', { client_phone: ctx.getters.clientPhone }, { root: true })
          }
        })
        .catch(() => ctx.commit('SET_ERROR_FROM_SERVER', ctx.rootGetters.translations('server_error')))
        .finally(() => ctx.dispatch('SET_LOADING_COMPONENT', { paymentsTypes: false }, { root: true }))
    },
    SET_PAY_PARTS_VALUE_ACTION: (ctx, value) => {
      ctx.commit('SET_PAYMENT_FORM_EMPTY', false)
      ctx.commit('SET_PAY_PARTS_VALUE', value)
    },
    SET_LEGAL_PERSON_INFO_COMPONENT_ACTION ({ commit }, methodId) {
      commit('SET_IS_PAYMENT_FORM_EMPTY_WARNING', false)
      if (!methodId) {
        commit('SET_LEGAL_PERSON_FORM_COMPONENT', null)
        return
      }
      switch (methodId) {
        case 'd558bfcc-7456-11df-ad52-000c29118aa7':
          commit('SET_LEGAL_PERSON_FORM_COMPONENT', FOPForm)
          break
        case '82a553c6-4f94-11e8-a3de-005056b2fc3d':
          commit('SET_LEGAL_PERSON_FORM_COMPONENT', FiliaForm)
          break
        default:
          commit('SET_LEGAL_PERSON_FORM_COMPONENT', OtherForm)
          break
      }
    },
    REPEAT_MONOBANK_PAYMENT ({ rootGetters, commit }, orderId) {
      return new Promise((resolve, reject) => {
        axios
          .get(rootGetters.urlLanguagePrefix + '/shop/checkout/repeat-monobank-payment/', { params: { orderId } })
          .then(res => {
            commit('SET_MONOBANK_REPEAT_STATUS', res.data.status)
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    SUBMIT_LIQPAY_FORM_ACTION (ctx, { data, url, signature }) {
      try {
        const liqpayForm = document.createElement('form')
        document.body.appendChild(liqpayForm)
        liqpayForm.method = 'POST'
        liqpayForm.action = url
        liqpayForm.acceptCharset = 'utf-8'
        liqpayForm.innerHTML = `
        <input name='data' type='hidden' value='${data}'>
        <input name='signature' type='hidden' value='${signature}'>
        `
        liqpayForm.submit()
      } catch (error) {}
    },
    SET_DOCUMENT_NDS_STATUS_ACTION ({ commit, rootState }, status) {
      const legalPersonInfo = rootState.checkout?.formData?.legalPersonInfo || {}

      commit('REDUCE_FORM_DATA', { legalPersonInfo: { ...legalPersonInfo, documentNdsStatus: status } })
    }
  }
}
